const setModalName = (modalName) => (ModalComponent) => {
  /* eslint-disable no-param-reassign */
  ModalComponent.modalName = modalName;

  return ModalComponent;
};

export default setModalName;
